import { api } from "./api";
import { ENDPOINTS } from "./endpoints";
import { operations } from "../types/openapi";
import { TRequestValues } from "./authClient/auth/api-utils";

type checkAddressOperation = operations["checkWallet"];
type manualCheckWalletOperation = operations["manualCheckWallet"];
type getByCheckIdOperation = operations["getByCheckId"];
type getUserWalletCheckListOperation = operations["getAll_1"];
type getRemainingDailyLimitOperation = operations["getRemainingDailyLimit"];

/**
 * Проверить кошелек
 */
export const getIdForWalletCheck = (
  params: checkAddressOperation["requestBody"]["content"]["application/json"]
): Promise<checkAddressOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.getIdForWalletCheck(), params);
};

/**
 * Проверить кошелек
 */
export const createUserWalletCheck = (
  address: manualCheckWalletOperation["requestBody"]["content"]["application/json"]
): Promise<manualCheckWalletOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.userWalletCheck(), address);
};

/**
 *  Получить информацию о проверке кошелька по Id (доступен для SENIOR_CUSTOMER, JUNIOR_CUSTOMER, SENIOR_LP, JUNIOR_LP, SENIOR_OPERATOR, JUNIOR_OPERATOR, RISK_MANAGER, SYSTEM_ADMIN, USER_ADMIN)
 */
export const getResultByCheckId = ({
  checkId,
}: getByCheckIdOperation["parameters"]["path"]): Promise<
  getByCheckIdOperation["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.userWalletCheckById(checkId));
};

/**
 *  Грид результатов проверки (доступен для SENIOR_CUSTOMER, JUNIOR_CUSTOMER, SENIOR_LP, JUNIOR_LP, SENIOR_OPERATOR, JUNIOR_OPERATOR, RISK_MANAGER, SYSTEM_ADMIN, USER_ADMIN)
 */
export const getUserWalletCheckList = (
  params: Record<string, TRequestValues>
): Promise<getUserWalletCheckListOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.userWalletCheck(), params);
};

/**
 * Возвращает количество проверок, которые можно выполнить до конца дня (доступен для SENIOR_CUSTOMER, JUNIOR_CUSTOMER, SENIOR_LP, JUNIOR_LP, SENIOR_OPERATOR, JUNIOR_OPERATOR, RISK_MANAGER, SYSTEM_ADMIN, USER_ADMIN)
 */
export const getRemainingDailyLimit = (): Promise<
  getRemainingDailyLimitOperation["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.remainingDailyLimit());
};
